import ApiService from "./base";
import { config } from "@/utils/config";
export default class AuthService extends ApiService {
    constructor(){
        super({
            baseURL: `${config.apiUrl}/auth`
        });
    }
    async login(credentials) {
        const response = await this.post({
            url: "/login",
            data: credentials
        });
        return response.data;
    }
    async changePassword(data) {
        const response = await this.post({
            url: "/change-password-challenge",
            data: {
                email: data.email,
                password: data.newPassword,
                session: data.session
            }
        });
        return response.data;
    }
    async logout() {
        await this.post({
            url: "/logout"
        });
    }
    async signup(signupData) {
        return this.post({
            url: "/signup",
            data: signupData
        });
    }
    async checkSession() {
        const response = await this.get({
            url: "/session"
        });
        return response.data;
    }
    async extendSession() {
        const response = await this.post({
            url: "/extend-session",
            data: {}
        });
        return response.data;
    }
}
